import * as React from "react";
const CMOSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={69}
    height={68}
    fill="none"
    {...props}
  >
    <rect
      width={60}
      height={60}
      x={4.668}
      y={4}
      fill="#040919"
      fillOpacity={0.02}
      rx={30}
    />
    <rect
      width={60}
      height={60}
      x={4.668}
      y={4}
      stroke="#040919"
      strokeOpacity={0.03}
      strokeWidth={8}
      rx={30}
    />
    <path
      fill="#040919"
      d="M47.066 23v4.5a1 1 0 1 1-2 0V24h-3.5a1 1 0 0 1 0-2h4.5a1 1 0 0 1 1 1Zm-1 16.5a1 1 0 0 0-1 1V44h-3.5a1 1 0 0 0 0 2h4.5a1 1 0 0 0 1-1v-4.5a1 1 0 0 0-1-1Zm-17.5 4.5h-3.5v-3.5a1 1 0 0 0-2 0V45a1 1 0 0 0 1 1h4.5a1 1 0 0 0 0-2Zm-4.5-15.5a1 1 0 0 0 1-1V24h3.5a1 1 0 0 0 0-2h-4.5a1 1 0 0 0-1 1v4.5a1 1 0 0 0 1 1Zm17 11.5a1 1 0 0 1-.8-.399 6.501 6.501 0 0 0-10.4 0 1 1 0 1 1-1.6-1.202 8.493 8.493 0 0 1 3.425-2.71 5 5 0 1 1 6.743 0 8.493 8.493 0 0 1 3.429 2.71A1 1 0 0 1 41.066 40Zm-6-5a3 3 0 1 0 0-5.999 3 3 0 0 0 0 5.999Z"
    />
  </svg>
);
export default CMOSVG;
